const cache: {[key: string]: {
  response: unknown,
  timestamp: number
}} = {};

export const getCache = async<T>(key: string, cacheExpiration: number = 2000): Promise<T | undefined> => {
  const cacheData = cache[key];
  if(cacheData && (new Date).getTime() - cacheData.timestamp < cacheExpiration)
    return await cacheData.response as T;
  return undefined;
};

export const setCache = (key: string, response: unknown) => {
  cache[key] = {
    response,
    timestamp: (new Date).getTime()
  };
};

export const withCache =
async<T, S extends unknown[]>(fun: (...args: S) => Promise<T>, args: S, cacheExpiration: number): Promise<T> =>  {

  // @ts-expect-error - This is a hack to get the function name
  const key = `${fun.name||fun.methodName}(${JSON.stringify(args)})`;

  const data = await getCache<T>(key, cacheExpiration);
  if(data !== undefined) return data;
  const cacheData = fun(...args);
  setCache(key, cacheData);
  return await cacheData;
};

export const clearCache = (functionKey: string, args?: unknown[]) => {
  // If fun is not defined, we clear the whole cache
  if(!functionKey) {
    for(const key in cache) delete cache[key];
    return;
  }
  // If there are args, we clear the one entry in the cache
  if(args) {
    delete cache[`${functionKey}(${JSON.stringify(args)})`];
    return;
  }
  // If there is a functionKey, but no args, we clear all the entries related to the fun
  for(const k in cache) {
    if(k.startsWith(`${functionKey}(`))
      delete cache[k];
  }

};
